import React, { useState } from "react";
import { Box, Typography, useMediaQuery, Grid } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import "../style/components.css";
import { OvalStar, CardIcon } from "../constant";

const MainContainer = styled(Box)(({ theme }) => ({
    background: "#000",
    display: "flex",
    flexDirection: "column",
    padding: "60px 24px",
    position: "relative",
    overflow: "hidden",
    width: "100%",
    margin: "0 auto",

    "&::after": {
        content: '""',
        position: "absolute",
        width: "90%",
        height: "90%",
        left: "70%",
        top: "0",
        transform: "translateX(-100%), translateY(-50%)",
        background:
            "radial-gradient(circle, rgba(99, 102, 241, 0.65) 0%, rgba(99, 102, 241, 0) 70%)",
        filter: "blur(100px)",
        //backdropFilter: "blur(500px)",
        zIndex: 0,
    },
}));

const ContentContainer = styled(Box)(({ theme }) => ({
    width: "100%", // Set to 95% width
    maxWidth: "1200px",
    margin: "0 auto",
    position: "relative",
    zIndex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    [theme.breakpoints.up("sm")]: {
        width: "100%",
    },
}));

const GlassBox = styled(Box)(({ theme }) => ({
    width: "100%",
    maxWidth: "100%",
    background: "linear-gradient(135deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.02) 100%)",
    backdropFilter: "blur(20px)",
    border: "1px solid rgba(255, 255, 255, 0.1)",
    borderRadius: "20px",
    borderWidth: "2px",
    borderStyle: "solid",
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    [theme.breakpoints.down("md")]: {
        width: '100%'
    },

}));

const CardsBox = styled(Box)(({ theme }) => ({
    width: "100%",
    maxWidth: "100%",
    margin: "0 auto",
    position: "relative",
    zIndex: 1,
    right: 'auto',
    left: 'auto',
    marginTop: theme.spacing(4),
    [theme.breakpoints.up("md")]: {
        marginTop: theme.spacing(6),
    },
    [theme.breakpoints.up("sm")]: {
        marginTop: theme.spacing(6),
        right: 'auto',
        left: 'auto',
    },
}));

const IndustriesVideoSection = ({ data }) => {
    const theme = useTheme();
    const { title, subTitle, videoUrl, cardData, para } = data;
    const [isPlaying, setIsPlaying] = useState(false);
    const [showControls, setShowControls] = useState(true);

    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const handleMouseMove = () => {
        setShowControls(true);
    };




    return (
        <MainContainer>
            <ContentContainer>
                <Box sx={{
                    width: { xs: "100%", md: "80%" },
                    textAlign: { xs: "left", md: "center" },
                    mb: { xs: 2, md: 5 },
                }}>
                    <Typography variant="h2" sx={{
                        background: "linear-gradient(135deg, #6366F1 0%, #3B82F6 100%)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        fontSize: { xs: 24, sm: 32, md: 40 },
                        fontWeight: 700,
                    }}>
                        {title}
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },  // Stack on mobile, row on desktop
                        alignItems: { xs: "left", md: "center" },  // Center on mobile, align in line on desktop
                        width: { xs: "100%", md: "90%" },
                        mb: { xs: 5, md: 10 },
                    }}
                >
                    <Typography sx={{
                        color: "#8C8CC2",
                        fontSize: { xs: 14, md: 18 },
                        lineHeight: 1.6,

                    }}>
                        {subTitle}
                    </Typography>
                </Box>

                <GlassBox>
                    <Box
                        sx={{
                            position: "relative",
                            width: isMobile ? "95%" : "97%",
                            height: { xs: "240px", sm: "350px", md: "500px" },
                            backgroundColor: "#000",
                            overflow: "hidden",
                            margin: "14px auto 14px",
                            borderRadius: "12px",
                        }}
                        onMouseMove={handleMouseMove}
                        onMouseLeave={() => isPlaying && setShowControls(false)}
                    >
                        <Box
                            autoPlay
                            muted
                            playsInline
                            preload="metadata"
                            component="video"
                            src={videoUrl}
                            sx={{ width: "100%", height: "100%", objectFit: "cover" }}
                            onEnded={() => setIsPlaying(false)}
                        />


                    </Box>
                </GlassBox>


                <CardsBox>
                    <Grid container spacing={1.2} justifyContent="left">
                        {cardData?.map((card, index) => (
                            <Grid item xs={12} sm={6} md={3} key={index}>
                                <Box className="industrie-action-card4">
                                    <Box className="industrie-card-body">
                                        <Box className="image-placeholder">
                                            <img src={card?.icon || CardIcon} className="card-icon-ind" alt="Card Icon" />
                                            <Typography variant="h5" className="intro-text-ind">
                                                {card.title}
                                            </Typography>
                                        </Box>
                                        <Box className="info-ind">
                                            <Typography variant="h5">{card.title}</Typography>
                                            <Typography>{card.description}</Typography>
                                        </Box>
                                    </Box>
                                </Box>
                            </Grid>
                        ))}

                        {/* Paragraph should appear after the last card in the row */}
                        {cardData.length > 0 && (
                            <Grid item xs={12} sm={6} md={3}>
                                <Box sx={{ width: "100%", p: 2 }}>
                                    <Typography sx={{ color: "#8C8CC2", fontSize: { xs: 16, md: 16 }, lineHeight: 1.6 }}>
                                        {para}
                                    </Typography>
                                </Box>
                            </Grid>
                        )}
                    </Grid>

                </CardsBox>
            </ContentContainer>
        </MainContainer>
    );
};

export default IndustriesVideoSection;